import { useCallback, useState } from 'react'

export function useBrokenImages() {
  const [broken, setBroken] = useState<Set<string>>(new Set())

  const markBroken = useCallback((url: string) => {
    setBroken((prev) => {
      if (prev.has(url)) return prev
      const next = new Set(prev)
      next.add(url)
      return next
    })
  }, [])

  const isBroken = useCallback((url: string) => broken.has(url), [broken])

  return { isBroken, markBroken }
}
